import { boolean, object } from "superstruct";

const RewardsStorefrontValuesProgramsStatusSchema = object({
    pointsProgramEnabled: boolean(),
    referralProgramEnabled: boolean(),
    tiersProgramEnabled: boolean(),
    b2bProgramEnabled: boolean(),
});

export default RewardsStorefrontValuesProgramsStatusSchema;
